
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'StatisticBar'
})
export default class StatisticBar extends Vue {
  @Prop()
  private barPercentage: number;

  get widthPercentage() {
    return `${this.barPercentage * 100}%`;
  }
}
